<template>
  <div v-if="isShow">
    <div id="phoneStrip-wrapper" ref="phoneStrip" v-if="!isHangUp">
      <div class="c-flex">
        <div style="display: flex; flex: 1 1 0%; align-items: center">
          <div class="c-flex flex-d-column m-l-15 c-m-r-15">
            <i
              style="text-align: center; line-height: 30px"
              class="el-icon-phone-outline c_white"
            ></i>
            <span class="c_white">{{ timingStr }}</span>
          </div>
          <div>
            <div class="c_white c-font-bold" style="font-size: 18px">
              {{ osg.codelabel('callMode', callMode) || '拨号中' }} ：{{
                objectData.formData.phone
              }}
            </div>
            <div>
              <span class="c_white">
                {{
                  `${formatProvince(objectData.formData.province) || ''}${formatCity(
                    objectData.formData.city
                  ) || ''}${formatDistrict(objectData.formData.district) || ''}`
                }}
              </span>
            </div>
          </div>
        </div>
        <el-menu
          :background-color="profileTheme.themeColor"
          class="menu-wrapper"
          :default-active="null"
          mode="horizontal"
          @select="handleSelect"
          text-color="#fff"
        >
          <el-menu-item index="1">
            <template slot="title">
              <span class="m-r-5">挂断</span>
              <i class="c_white el-icon-phone" style="transform: rotate(135deg)"></i>
            </template>
          </el-menu-item>
          <!-- <el-menu-item index="2">
            <template slot="title" v-if="isBack">
              <span class="m-r-5">保持</span>
              <i class="c_white el-icon-phone-outline"></i>
            </template>
            <template slot="title" v-else>
              <span class="m-r-5">取回</span>
              <i class="c_white el-icon-thumb"></i>
            </template>
          </el-menu-item> -->
          <!-- <el-menu-item index="3" v-if="isBack">
            <template slot="title" v-if="!isTransfer">
              <span class="m-r-5">转移</span>
              <i class="c_white el-icon-position"></i>
            </template>
            <template slot="title" v-else>
              <span class="m-r-5">取消转移</span>
              <i class="c_white el-icon-close"></i>
            </template>
          </el-menu-item> -->
          <!-- <el-menu-item index="4" v-if="isBack && isTransfer && callMode == '6'">
            <template slot="title">
              <span class="m-r-5">确定转移</span>
              <i class="c_white el-icon-position"></i>
            </template>
          </el-menu-item> -->
          <el-menu-item index="5" v-if="record.openRecord">
            <!-- @click="isPopUp = false" -->
            <template slot="title">
              <span class="m-r-5">重新弹屏</span>
              <i class="c_white el-icon-rank"></i>
            </template>
          </el-menu-item>
          <el-menu-item index="6">
            <!-- @click="isPopUp = false" -->
            <template slot="title">
              <span class="m-r-5">关闭</span>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
    </div>

    <!-- 呼叫弹窗 -->
    <el-dialog
      id="comprehensiveDialog"
      class="phoneStrip-dialog"
      v-if="!isPopUp && record.openRecord && !isTransfer"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="!isPopUp && record.openRecord && !isTransfer"
      @close="
        record.recordFormData = { exts: {} };
        record.SArecordFormData = {
          gpsPoint: {},
          exts: {}
        };
      "
    >
      <template v-if="!isTransfer">
        <c-form
          :formData="record.recordFormData"
          :fields="recordFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
          :options="options"
          ref="recordFormData"
          :upload="upload"
          labelWidth="100px"
          :area="area"
          :inline="true"
          labelPosition="top"
        ></c-form>
        <el-tabs type="border-card" class="c-m-t-10">
          <el-tab-pane
            label="NPS回访"
            v-if="
              $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'NPS') ||
                objectData.handleType == 'NPS'
            "
          >
            <c-form
              :formData="record.NPSformData"
              :fields="extFieldsNPS.filter(item => !item.frontEndConfig.phoneStripFormHide)"
              :options="options"
              ref="NPSform"
              :upload="upload"
              labelWidth="100px"
              :area="area"
            >
              <template slot="questionAndReply">
                <el-card class="box-card" shadow="hover">
                  <div
                    slot="header"
                    class="c-flex c_item_center"
                    style="justify-content: space-between"
                  >
                    <span>问题库</span>
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      @click="
                        record.NPSformData.questionAndReply.push({
                          question: '',
                          reply: '',
                          whether: ''
                        })
                      "
                      :disabled="record.NPSformData._id ? true : false"
                      v-if="!record.NPSformData._id"
                    >
                      新增
                    </el-button>
                  </div>
                  <div
                    v-for="(item, index) in record.NPSformData.questionAndReply"
                    :key="index"
                    :class="
                      `${
                        record.NPSformData.questionAndReply.length - 1 == index ? '' : 'c-m-b-20 '
                      }`
                    "
                  >
                    <div :class="`c-flex c-flex-item c-flex-between`">
                      <el-select
                        :disabled="record.NPSformData._id ? true : false"
                        v-model="item.question"
                        placeholder="请选择问题"
                        style="flex: 2"
                        @change="selectionQuestion($event, item)"
                      >
                        <el-option
                          v-for="subItem in options['questionBank']"
                          :key="subItem._id"
                          :label="subItem.name"
                          :value="subItem.name"
                          :disabled="
                            record.NPSformData.questionAndReply.some(
                              l => l.question == subItem.name
                            )
                          "
                        ></el-option>
                      </el-select>
                      <div style="flex: 1;align-items: center;" class="c-flex c-flex-around">
                        <el-radio-group
                          v-model="item.whether"
                          :disabled="record.NPSformData._id ? true : false"
                          class="c-flex c-m-l-10"
                        >
                          <el-radio
                            v-for="item in options['NPSreply']"
                            :key="item.value"
                            :label="item.value"
                          >
                            {{ item.label }}
                          </el-radio>
                        </el-radio-group>

                        <el-link
                          v-if="!record.NPSformData._id"
                          :underline="false"
                          @click="record.NPSformData.questionAndReply.splice(index, 1)"
                        >
                          <i class="c-m-l-15 el-icon-delete"></i>
                        </el-link>
                      </div>
                    </div>
                    <div class="c_red" style="color: red" v-if="item.whether > 0 && item.question">
                      此选项则会生成{{ String(item.reply) }}元罚款！
                    </div>
                  </div>
                </el-card>
              </template>
            </c-form>
          </el-tab-pane>
          <el-tab-pane
            label="售后工单回访"
            v-else-if="
              $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'review') ||
                objectData.handleType == 'review'
            "
          >
            <c-form
              :formData="record.reviewFormData"
              :fields="reviewFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
              :options="options"
              ref="reviewFormData"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              :inline="true"
              labelPosition="top"
            ></c-form>
          </el-tab-pane>
          <el-tab-pane
            label="售后工单"
            v-else-if="
              $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', '404')
            "
          >
            <c-form
              :formData="record.SAafterSaleFormData"
              :fields="workOrderFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
              :options="options"
              ref="SAafterSaleFormData"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              :inline="true"
              labelPosition="top"
            ></c-form>
          </el-tab-pane>
          <el-tab-pane label="服务工单" v-else>
            <c-form
              :formData="record.SArecordFormData"
              :fields="SAextFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
              :options="options"
              ref="SArecordFormData"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              :inline="true"
              labelPosition="top"
            >
              <template slot="name">
                <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="record.SArecordFormData.name"
                  placeholder="请输客户名称"
                  @select="handleSelect"
                  hide-loading
                  value-key="name"
                >
                  <i class="el-icon-search el-input__icon" slot="suffix"></i>
                  <template slot-scope="{ item }">
                    <p class="c-flex c-flex-between">
                      <span>{{ item.name }}</span>
                      <span>{{ item.phone }}</span>
                    </p>
                  </template>
                </el-autocomplete>
              </template>
              <!-- <template slot="address">
                <el-autocomplete
                  v-model="record.SArecordFormData.address"
                  suffix-icon="el-icon-map-location"
                  :fetch-suggestions="osg.inputtips"
                  @select="inputtipsSelect"
                  autosize
                  type="textarea"
                  :trigger-on-focus="false"
                  :placeholder="'请输入'"
                >
                  <template slot-scope="{ item }">
                    <div class="c-flex">
                      <span>{{ item.name }}</span>
                      <span style="margin-left: 6px;color: #ccc;">
                        {{ item.district }}
                      </span>
                    </div>
                  </template>
                </el-autocomplete>
              </template> -->
            </c-form>
          </el-tab-pane>
          <el-tab-pane label="跟进记录">
            <div style="height: 100%; display: flex; flex-direction: column">
              <div style="height: 100%; display: flex; flex-direction: column">
                <div style="flex: 1">
                  <el-table ref="recordTable" height="calc(100% - 80px)" :data="record.fpi.data">
                    <c-table :fields="recordFields" :options="options"></c-table>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="历史线索">
            <div style="height: 100%; display: flex; flex-direction: column">
              <div style="height: 100%; display: flex; flex-direction: column">
                <div style="flex: 1">
                  <el-table ref="leadTable" height="calc(100% - 80px)" :data="leadFpi.data">
                    <c-table :fields="leadFields" :options="options" target="_blank"></c-table>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="任务备注" v-if="objectData.bizType == 'supportHubItem'">
            <div style="height: 100%; display: flex; flex-direction: column">
              <div style="height: 100%; display: flex; flex-direction: column">
                <div style="flex: 1">
                  <c-form
                    :formData="SupportHubItemData"
                    :fields="
                      SupportHubItemFields.filter(item => !item.frontEndConfig.phoneStripFormHide)
                    "
                    :options="options"
                    ref="SupportHubItemTable"
                    :upload="upload"
                    labelWidth="100px"
                    :inline="true"
                    labelPosition="top"
                  ></c-form>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-divider content-position="left">
          <i class="el-icon-s-claim c_blue_default"></i>
          历史服务工单
        </el-divider>
        <el-table ref="ASTable" max-height="250px" :data="serviceAppointmentFpi.data">
          <c-table :fields="SAextFields" :options="options" target="_blank"></c-table>
        </el-table>
        <el-divider content-position="left">
          <i class="el-icon-service c_blue_default"></i>
          历史售后工单
        </el-divider>
        <el-table ref="ASTable" max-height="250px" :data="fpi.data">
          <c-table :fields="workOrderFields" :options="options" target="_blank"></c-table>
        </el-table>
        <div slot="footer" style="display: flex; justify-content: flex-end">
          <el-button
            type="primary"
            @click="saveRecord(0)"
            :disabled="disableBtn"
            v-if="objectData.handleType == 'NPS'"
          >
            保存跟进记录
          </el-button>
          <template v-if="objectData.handleType == 'NPS'">
            <el-button type="primary" @click="saveRecord(3)" :disabled="disableBtn">
              创建NPS
            </el-button>
          </template>
          <el-button
            type="primary"
            @click="saveRecord('4')"
            :disabled="disableBtn"
            v-else-if="
              $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'review') ||
                objectData.handleType == 'review'
            "
          >
            创建售后工单回访
          </el-button>
          <template v-else>
            <el-button
              plain
              type="danger"
              @click="saveRecord(2)"
              :disabled="disableBtn"
              v-if="$util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', '404')"
            >
              创建售后工单
            </el-button>
            <el-button
              v-if="objectData.bizType != 'supportHubItem'"
              type="primary"
              @click="saveRecord(0)"
              :disabled="disableBtn"
            >
              保存跟进记录
            </el-button>
            <el-button
              type="primary"
              @click="saveSupportHubItem()"
              :disabled="disableBtn"
              v-if="objectData.bizType == 'supportHubItem'"
            >
              保存任务备注
            </el-button>
            <el-button
              type="primary"
              @click="saveRecord(1)"
              :disabled="disableBtn"
              v-if="
                !$util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', '404')
              "
            >
              建 单
            </el-button>
          </template>
          <el-button @click="cancel" :disabled="disableBtn">取 消</el-button>
        </div>
      </template>
    </el-dialog>

    <div v-show="!isPopUp && isTransfer">
      <el-dialog
        title="转移客服"
        v-if="!isPopUp && isTransfer"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="isTransfer"
        id="transferDialog"
      >
        <div style="width: 100%; min-height: 500px">
          <el-table
            ref="correspondentTable"
            :data="correspondentList"
            empty-text="暂无人员"
            height="500px"
          >
            <el-table-column prop="code" label="编号" min-width="100"></el-table-column>
            <el-table-column label="姓名" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="150px"></el-table-column>
            <el-table-column label="性别" width="100px">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.sex == '1' ? '女' : scope.row.sex == '0' ? '男' : '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="150px"></el-table-column>
            <el-table-column label="操作" :width="80" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click.native.prevent="transferHandle(scope.row)">
                  转移
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
// import areajs from '../resources/js/area.js';
// import areaList from '../resources/js/areaList.js';

export default {
  name: 'phoneStrip',
  inject: ['viewReload'], //注入NabMenu里的viewReload方法
  props: {
    //客服标识
    serviceState: {
      type: String
    },
    //个性化配置
    profileTheme: {
      type: Object
    },
    //页面数据对象
    objectData: {
      type: Object
    },
    //字典表
    options: {
      type: Object
    }
  },
  data() {
    return {
      rules: this.$util.rules,
      isPopUp: false, //弹屏按钮
      storagetransfer: {}, //要转移给的客服对象
      // phoneStripPopUp: '', //控制弹屏
      timingHour: 0, //时
      timingMinute: 0, //分
      timingSecond: 0, //秒
      timeInterval: null, //时分秒计时器
      queryCallStateInterval: null, //查询通话状态定时器
      isBack: true, //保持/取回
      isHangUp: false, //挂断
      isTransfer: false, //转移
      isConfirmTransfer: false, //转移
      //   options: {
      //     codecfg_callMode: { codeId: 'callMode' }
      //   },
      callMode: '', //通话状态
      isShow: true,
      // 跟进记录列表
      record: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: [],
        openRecord: true, // 跟进记录弹窗
        recordFormData: { exts: { sourceType: '4', workflowDefId: '8191527117502723955' } }, //跟进记录表单
        reviewFormData: { memo: '', exts: {} }, //回访表单
        SAafterSaleFormData: { sid: '', relatedPerson: [] }, //售后工单表单
        SArecordFormData: { gpsPoint: {}, exts: {} }, //跟进记录表单-下（工单信息）
        NPSformData: { questionAndReply: [] }, //NPS表单
        callData: [], //跟进记录-通话记录
        openCallRecord: false //跟进记录-通话记录弹窗
      },
      area: {
        options: this.osg.areaList,
        props: {
          //   checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      extFields: [], //线索扩展字段
      recordFields: [], // 跟进记录字段
      workOrderFields: [], // 售后工单字段
      SAextFields: [], // 工单字段
      leadFields: [], // 线索字段
      SupportHubItemFields: [], //客服任务字段
      reviewFields: [], // 审核回访字段
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      correspondentList: [], //可转移的客服列表
      that: {},
      disableBtn: false, //控制按钮禁用防止网络延迟大导致重复提交
      //   questionBankList: [], //问题库
      randomQuestionNum: 3, //问题随机
      extFieldsNPS: [], //NPS所需表单字段
      fpi: { data: [] }, //列表数据
      serviceAppointmentFpi: { data: [] },
      leadFpi: { data: [] },
      searchValue: '', //搜索列表内容
      contractFpi: {}, //合同列表数据
      SupportHubItemData: {} //任务对象（从页面传来）
    };
  },
  async mounted() {
    // window.$this = this;这个不能打开，作为组件会影响$this的指向
    this.id = this.osg.param('id');
    this.that = this;
    //电话条上色
    if (this.$refs.phoneStrip)
      this.$refs.phoneStrip.style.background = this.profileTheme.themeColor;
    if (this.$refs.phoneStrippopUp)
      this.$refs.phoneStrippopUp.style.background = this.profileTheme.themeColor;

    clearInterval(this.timeInterval); //页面载入 清除时分秒定时器
    clearInterval(this.queryCallStateInterval); //页面载入 清除查询通话状态定时器

    // 获取跟进记录表字段
    this.osg.getFields(
      'followingUpNote',
      () => {
        this.getRecord();
        this.$forceUpdate();
      },
      this,
      'recordFields',
      null,
      null,
      { 'in:showList|string#and': '9' }
    );

    // 获取服务工单字段
    this.osg.getFields(
      'serviceAppointment',
      () => {
        // 获取历史服务工单
        this.getServiceAppointments();
      },
      this,
      'SAextFields',
      null,
      null,
      { 'in:showList|string#and': '9' }
    );

    // 获取售后工单字段
    this.osg.getFields(
      'workOrder',
      () => {
        // 获取历史售后工单
        this.getWorkOrders();
      },
      this,
      'workOrderFields',
      null,
      null,
      { 'in:showList|string#and': '9' }
    );

    // 获取线索字段
    this.osg.getFields(
      'lead',
      () => {
        // 获取历史线索
        this.getLeads();
      },
      this,
      'leadFields',
      null,
      null,
      { 'in:showList|string#and': '9' }
    );
    // 获取客服任务字段
    this.osg.getFields(
      'supportHubItem',
      () => {
        // // 获取客服任务
        // this.getLeads();
      },
      this,
      'SupportHubItemFields',
      null,
      null,
      { 'in:showList|string#and': '9' }
    );

    // 获取回访字段
    this.osg.getFields(
      'review',
      () => {
        this.$refs.reviewFormData && this.$refs.reviewFormData.$forceUpdate();
      },
      this,
      'reviewFields',
      null,
      null,
      {
        'in:showList|string#and': '9'
      }
    );

    //如果是NPS则调用NPS动态表单
    if (this.objectData.handleType == 'NPS') {
      this.getExtFieldsNPS(() => {
        this.init();
      });
    } else {
      this.init();
    }
  },
  methods: {
    init() {
      this.osg.codeoption(() => {
        this.timeInterval = setInterval(() => {
          //时分秒计算
          this.timingSecond = +this.timingSecond + 1;
          this.timingMinute = this.timingMinute + parseInt(+this.timingSecond / 60);
          this.timingHour = this.timingHour + parseInt(+this.timingMinute / 60);
          if (+this.timingSecond == 60) this.timingSecond = 0;
          if (+this.timingMinute == 60) this.timingMinute = 0;
        }, 1000);
        this.$once('hook:beforeDestroy', () => {
          clearInterval(this.timeInterval);
        });
        //轮询调用，查询通话状态
        // this.getByCallState(this.objectData);
        // this.queryCallStateInterval = setInterval(() => {
        //   this.getByCallState(this.objectData);
        // }, 6000);
        // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
        this.$once('hook:beforeDestroy', () => {
          clearInterval(this.timeInterval); //清除时分秒定时器
          clearInterval(this.queryCallStateInterval); //清除查询通话状态定时器
        });
        //初始化表单
        this.initForm();
      }, this);
    },
    //打开跟进记录弹窗
    initForm() {
      if (this.objectData.handleType == 'NPS') {
        this.initNpsForm(); //初始化NPS表单
      } else if (this.objectData.handleType == 'review') {
        this.initReviewForm();
      } else {
        this.initSA(); //初始化 服务工单、售后工单
      }
    },
    //初始化 服务工单、售后工单
    initSA() {
      this.record.recordFormData = { exts: {} };
      let tempFormData = this.$util.deepCopy(this.converTemp(this.objectData.formData)); //从页面传来的数据模板
      this.SupportHubItemData = this.$util.deepCopy(this.objectData.formData);
      this.SupportHubItemData.taskStatus = JSON.stringify(this.SupportHubItemData.taskStatus);
      tempFormData.exts.sourceType = tempFormData.exts.sourceType || '4';
      tempFormData.serviceType = tempFormData.serviceType || '11';
      tempFormData.exts.workflowDefId = '8191527117502723955';
      this.record.SArecordFormData = this.$util.deepCopy(tempFormData);
      //给售后工单表单赋默认值
      this.$set(this.record.SAafterSaleFormData, 'name', tempFormData.name);
      this.$set(this.record.SAafterSaleFormData, 'phone', tempFormData.phone);
      // 查询区下级街道选项，不延时请求会被subdistricts字典覆盖。
      setTimeout(() => {
        this.osg.getSubdistricts(this.record.SArecordFormData.area, result => {
          this.$set(window.$this.options, 'subdistricts', result);
        });
      }, 2000);
    },
    //初始化NPS表单
    initNpsForm() {
      this.record.recordFormData._id = this.randomUUid();
      this.record.recordFormData.name = this.objectData.formData.name;
      this.record.recordFormData.phone = this.objectData.formData.phone;
      this.record.recordFormData.callPhone = this.objectData.formData.phone;
      this.record.recordFormData.dedicateMode = ['NPS'];

      //如果关联合同第二次拨号 则反显
      this.getNPS({ bizId: this.objectData.bizId, bizType: this.objectData.bizType }, NPSdata => {
        this.getForfeitRules(1, 'questionBank', () => {
          if (NPSdata) {
            //给选项设置默认值
            NPSdata.questionAndReply = NPSdata.questionAndReply.map(item => {
              if (!item.whether) item.whether = '0';
              return item;
            });
            this.record.NPSformData = NPSdata || {};
            if (this.record.NPSformData.mode) delete this.record.NPSformData.mode; //清空回访状态
            // this.options['questionBank_random'] = this.options['questionBank'];
          } else {
            this.record.NPSformData = { questionAndReply: [] };
            // this.options['questionBank_random'] = [];
            let questionBankCopy = this.$util.deepCopy(this.options['questionBank']);
            //随机给出nps问题
            for (let i = this.randomQuestionNum; i > 0; i--) {
              let randomNum = Math.floor(Math.random() * questionBankCopy.length);
              // this.options['questionBank_random'].push(questionBankCopy[randomNum]);
              this.record.NPSformData.questionAndReply.push({
                id: questionBankCopy[randomNum]._id,
                question: questionBankCopy[randomNum].name,
                reply: questionBankCopy[randomNum].price || '0',
                whether: ''
              });
              questionBankCopy.splice(randomNum, 1);
            }
          }
        });
      });
    },
    //初始化回访表单
    initReviewForm() {
      if (this.objectData.formData) {
        // 将回访信息带到跟进记录
        this.record.recordFormData._id = this.randomUUid();
        this.record.recordFormData.name = this.objectData.formData.name;
        this.record.recordFormData.phone = this.objectData.formData.phone;
        this.record.recordFormData.callPhone = this.objectData.formData.phone;
        this.record.recordFormData.dedicateMode = ['review'];

        this.record.reviewFormData = Object.assign(
          this.record.reviewFormData,
          this.objectData.formData
        );
        this.$forceUpdate();
      }
    },
    getForfeitRules(type, sourceTypeType, callBack) {
      if (!sourceTypeType) return;
      this.osg.ajax(
        'basic/forfeitRule/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:type|integer#and': type
        },
        res => {
          this.options[sourceTypeType] = res.data;
          if (callBack) callBack();
        },
        { noload: true }
      );
    },
    //获取NPS表单
    getExtFieldsNPS(callback) {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'netPromoterScore',
          _all: '1',
          'is:state|integer#and': 1,
          //   'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFieldsNPS = res.data;
          this.options = this.options || [];
          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          if (callback) callback();
        },
        { noload: true }
      );
    },
    //获取NPS列表
    getNPS(params, callback) {
      this.osg.ajax(
        'basic/nps/query.do',
        params,
        res => {
          if (res.data) {
            if (callback) callback(res.data[0]);
          }
        },
        {
          noload: true
        }
      );
    },
    //操作
    handleSelect(el) {
      if (el == '1') this.hangUp(); //挂断
      if (el == '2') this.keep(this.objectData); //保持/取消保持
      if (el == '3') this.transfer(this.objectData); //转移
      if (el == '4') this.confirmTransfer(this.objectData); //确定转移
      if (el == '5') this.popUp(this.objectData); //弹屏
      if (el == '6') this.closeFn(); //弹屏
      console.log(el);
    },
    // 查询当前通话状态
    getByCallState(data) {
      this.osg.ajax(
        'basic/sobot/queryByCallState.do',
        {
          bizId: data.bizId,
          bizType: data.bizType,
          callId: data.callId
        },
        res => {
          this.callMode = res.data;
          //   this.$prompt('挂断', '提示', { //模拟挂断
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消'
          //   })
          //     .then(({ value }) => {
          //       that.isHangUp = true; //挂了就隐藏电话条
          //       that.isTransfer = false; //隐藏转移按钮
          //       clearInterval(this.timeInterval); //清除时分秒定时器
          //       clearInterval(this.queryCallStateInterval); //清除查询通话状态定时器
          //     })
          //     .catch(() => {
          //
          //     });
          if (res.data == '99') {
            this.isHangUp = true; //挂了就隐藏电话条
            this.isTransfer = false; //隐藏转移按钮
            clearInterval(this.timeInterval); //清除时分秒定时器
            clearInterval(this.queryCallStateInterval); //清除查询通话状态定时器
          }
        },
        { noload: true }
      );
    },
    //挂断
    // hangUp(data, direct) {
    //   let that = this;
    //   let fn = function(data) {
    //     that.osg.ajax(
    //       'basic/sobot/handleAgentCallHangUp.do',
    //       {
    //         bizId: data.bizId,
    //         bizType: data.bizType,
    //         callId: data.callId
    //       },
    //       () => {
    //         that.isHangUp = true;
    //         that.isTransfer = false;
    //         // console.log(that.isHangUp);
    //         // that.$forceUpdate();
    //         // if (that.isHangUp === false) that.$set(that.record, 'openRecord', that.isHangUp);
    //         // that.$emit('phoneStripFn', { isHangUp: that.isHangUp });
    //         // this.$emit('phoneStripFn', { isTransfer: false }); //取消转移
    //       },
    //       { noload: true }
    //     );
    //   };
    //   direct ? fn(data) : this.osg.confirm('确定挂断电话吗？', () => fn(data));
    // },
    // 挂断
    hangUp() {
      this.osg.confirm('确定要挂断吗？', () => {
        // this.isHangUp = true;
        // this.isTransfer = false;
        clearInterval(this.timeInterval); //页面载入 清除时分秒定时器
        clearInterval(this.queryCallStateInterval); //页面载入 清除查询通话状态定时器
        this.osg.ajax(
          'basic/sobot/agentHangup.do',
          {},
          () => {
            // this.queryHasCall({ del: '1' });
            // this.doInit();
          },
          { noload: true }
        );
      });
    },
    closeFn() {
      this.osg.confirm('确定要关闭吗？', () => {
        this.isHangUp = true;
        this.isTransfer = true;
        this.isPopUp = true;
      });
    },
    //保持
    keep(data) {
      let url = this.isBack ? 'basic/sobot/handleAgentHold.do' : 'basic/sobot/handleAgentUnhold.do';
      this.osg.ajax(
        url,
        {
          bizId: data.bizId,
          bizType: data.bizType,
          callId: data.callId,
          caller: data.caller
        },
        () => {
          this.isBack = !this.isBack;
          //   this.$emit('phoneStripFn', { isTransfer: false }); //取消转移
        },
        { noload: true }
      );
    },
    //转移
    transfer(data) {
      if (this.isTransfer) {
        this.osg.confirm('确定取消转移吗？', () => {
          this.osg.ajax(
            'basic/sobot/handleAgentConsultBack.do',
            {
              bizId: data.bizId,
              bizType: data.bizType,
              userId: this.storagetransfer._id,
              callId: data.callId
            },
            () => {
              this.osg.toast('取消转移成功！');
              this.isTransfer = !this.isTransfer;
            }
          );
        });
      } else {
        this.osg.confirm('确定转移吗？', () => {
          this.getCorrespondent();
          this.isTransfer = !this.isTransfer;
        });
      }
    },
    //确定转移
    confirmTransfer(data) {
      this.osg.confirm(`确定转移给"${this.storagetransfer.name}" 吗？`, () => {
        this.osg.ajax(
          'basic/sobot/handleAgentTransferConfirm.do',
          {
            bizId: data.bizId,
            bizType: data.bizType,
            userId: this.storagetransfer._id,
            callWay: this.storagetransfer.callWay,
            callId: data.callId
          },
          () => {
            this.osg.toast('转移成功！');
            this.isConfirmTransfer = false;
          },
          { noload: true }
        );
      });
    },
    //模拟调用接口
    myMockAjax(url, data, callback) {
      setTimeout(() => {
        if (callback) callback({ data: null });
      }, 200);
    },
    //模拟调用接口，返回值JSON
    myMockJSONAjax(url, data, callback) {
      setTimeout(() => {
        if (callback) callback(JSON.stringify({ data: null }));
      }, 200);
    },
    //请求客服列表（当前空闲的客服）
    getCorrespondent() {
      let params = {
        // 'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'asc',
        bizId: this.objectData.bizId,
        bizType: this.objectData.bizType,
        callId: this.objectData.callId,
        caller: this.objectData.formData.phone
      };
      this.osg.ajax(
        'basic/sobot/usableAgentTransferList.do',
        params,
        res => {
          this.correspondentList = res.data;
          this.$nextTick(() => {
            this.$refs.correspondentTable.doLayout();
            this.$forceUpdate();
          });
        },
        { noload: true }
      );
    },
    //转客服按钮
    transferHandle(row) {
      this.storagetransfer = row || {};
      this.osg.confirm(`确定转移给"${row.name}" 吗？`, () => {
        this.osg.ajax(
          'basic/sobot/handleAgentTransfer.do',
          {
            bizType: this.objectData.bizType,
            bizId: this.objectData.bizId,
            userId: row._id,
            callId: this.objectData.callId,
            callWay: row.callWay
          },
          () => {
            this.osg.toast('转移成功！');
          },
          { noload: true }
        );
      });
    },
    //弹屏
    popUp() {
      // handleAgentTransferConfirm
      this.isPopUp = !this.isPopUp;
      //   this.$emit('phoneStripFn', { isTransfer: false }); //取消转移
    },
    //取消
    cancel() {
      this.record.openRecord = false;
      //   this.hangUp(this.objectData, true);
      // if(this.isHangUp) {
      //     this.osg.confirm('您正在通话，确定挂断电话吗？', () => {
      //         this.hangUp(this.objectData,ture);
      //     })
      // }else{

      // }
    },
    //保存跟进记录确定按钮
    saveRecord(state) {
      //保存状态，生成跟进记录
      if (state == 0) {
        if (this.validate('recordFormData')) {
          if (this.osg.isRepeatClick('saveRecord', 5000)) {
            return;
          }
          this.disableBtn = true; // 提交了就禁用按钮
          //过了20秒接口没有响应恢复按钮
          setTimeout(() => {
            this.disableBtn = false; //恢复禁用的按钮
          }, 20000);
          this.saveRecordAjax(this.record.recordFormData, () => {
            // this.getData();
            this.hangUp(this.objectData, true); //挂断电话
            this.record.recordFormData = { exts: {} };
            this.record.SArecordFormData = {};
            this.record.openRecord = false;
            this.disableBtn = false; //恢复禁用的按钮
            this.viewReload();
            this.osg.toast('保存成功！');
          });
        }
      } else if (state == 1) {
        //生成跟进记录并建单
        let SArecordFormData = this.$util.deepCopy(this.record.SArecordFormData);
        if (this.validate('recordFormData') && this.validate('SArecordFormData')) {
          if (this.osg.isRepeatClick('saveRecord', 20000)) {
            return;
          }
          this.disableBtn = true; // 提交了就禁用按钮
          //过了20秒接口没有响应恢复按钮
          setTimeout(() => {
            this.disableBtn = false; //恢复禁用的按钮
          }, 20000);
          const UUID = this.randomUUid();
          //将线索与客户互相关联的特色接口，如果手机号在系统中没有，则新增联系人
          let upsertLeadData = this.$util.deepCopy(this.objectData.formData);

          console.log('这个地方循环的时候报大错', this.objectData);

          //如果建单的信息与线索的信息不同，则采用建单的信息

          for (let item of this.objectData.extFields) {
            if (item.preset === 1) {
              if (SArecordFormData[item.name])
                upsertLeadData[item.name] = SArecordFormData[item.name];
            } else if (item.preset === 0) {
              if (SArecordFormData.exts[item.name])
                upsertLeadData.exts[item.name] = SArecordFormData.exts[item.name];
            }
          }
          //将线索与客户互相关联的特色接口，如果手机号在系统中没有，则新增联系人
          this.upsertLead(upsertLeadData, contactsData => {
            //跟进记录对象赋值表单字段
            if (SArecordFormData.area.length > 0) {
              SArecordFormData.province = SArecordFormData.area[0] || '';
              if (SArecordFormData.area.length > 1) {
                SArecordFormData.city = SArecordFormData.area[1] || '';
                if (SArecordFormData.area.length > 2) {
                  SArecordFormData.district = SArecordFormData.area[2] || '';
                }
              }
            }
            //工单信息冗余存储到跟进记录
            this.record.recordFormData._id = UUID;
            this.record.recordFormData.name = SArecordFormData.name;
            this.record.recordFormData.phone = SArecordFormData.phone;
            this.record.recordFormData.province = SArecordFormData.province;
            this.record.recordFormData.city = SArecordFormData.city;
            this.record.recordFormData.district = SArecordFormData.district;
            this.record.recordFormData.address = SArecordFormData.address;
            this.record.recordFormData.channel = SArecordFormData.channel;
            this.record.recordFormData.leakagesite = JSON.stringify(
              SArecordFormData.exts.leakagesite
            );
            //跟进记录存到客户手机号码
            this.saveRecordAjax(this.record.recordFormData, () => {
              //给工单对象赋上线索id与客户id
              SArecordFormData.leadIds = [this.id];
              SArecordFormData.contactIds = [contactsData._id];
              //TODO: 工单扩展字段存储与跟进记录相同的id
              SArecordFormData.exts.followingUpNoteId = this.record.recordFormData._id;

              this.doSaveSA(SArecordFormData, SAData => {
                this.hangUp(this.objectData, true); //挂断电话
                this.viewReload();
                this.disableBtn = false; //恢复禁用的按钮
                // this.getData(() => {
                this.record.recordFormData = { exts: {} };
                this.record.SArecordFormData = {};
                this.record.openRecord = false;
                // });
              });
            });
          });
        }
      } else if (state == 2) {
        //售后工单
        console.log(this.record);
        if (this.validate('recordFormData') && this.validate('SAafterSaleFormData')) {
          if (this.osg.isRepeatClick('saveRecord', 20000)) {
            return;
          }
          this.disableBtn = true; // 提交了就禁用按钮
          //过了20秒接口没有响应恢复按钮
          setTimeout(() => {
            this.disableBtn = false; //恢复禁用的按钮
          }, 20000);
          this.saveRecordAjax(this.record.recordFormData, recordData => {
            //线索id赋值到售后工单上
            if (this.objectData.bizType == 'Lead')
              this.record.SAafterSaleFormData.leadIdAfterSale = this.objectData.formData._id;
            //跟进记录id赋值到售后工单上
            this.record.SAafterSaleFormData.followingUpNoteIdAfterSale = recordData._id;
            //通话记录id赋值到售后工单上
            this.record.SAafterSaleFormData.callIdAfterSale = this.objectData.callId;
            this.saveWorkflowAlert(this.record.SAafterSaleFormData, () => {
              this.hangUp(this.objectData, true); //挂断电话
              this.disableBtn = false; //恢复禁用的按钮
              this.record.recordFormData = { exts: {} };
              this.record.openRecord = false;
              this.viewReload();
            });
          });
        }
      } else if (state == 3) {
        //NPS
        if (this.validate('recordFormData')) {
          if (
            this.record.NPSformData.questionAndReply.some(item => !item.question || !item.whether)
          ) {
            this.osg.toast('NPS问题或回答不能为空！', 'warning');
            return;
          }
          if (!this.validateCForm()) return;
          if (this.osg.isRepeatClick('saveRecord', 5000)) {
            return;
          }
          this.disableBtn = true; // 提交了就禁用按钮
          //过了20秒接口没有响应恢复按钮
          setTimeout(() => {
            this.disableBtn = false; //恢复禁用的按钮
          }, 20000);
          console.log(this.record.NPSformData);
          this.saveRecordAjax(this.record.recordFormData, () => {
            //保存NPS
            this.saveNPS(this.record.NPSformData, () => {
              this.hangUp(this.objectData, true); //挂断电话
              this.record.recordFormData = { exts: {} };
              this.record.openRecord = false;
              this.disableBtn = false; //恢复禁用的按钮
              this.viewReload();
              this.osg.toast('保存成功！');
            });
          });
        }
      } else if (state == 4) {
        if (this.validate('recordFormData') && this.validate('reviewFormData')) {
          if (this.osg.isRepeatClick('saveRecord', 20000)) {
            return;
          }
          this.disableBtn = true; // 提交了就禁用按钮
          //过了20秒接口没有响应恢复按钮
          setTimeout(() => {
            this.disableBtn = false; //恢复禁用的按钮
          }, 20000);
          this.saveRecordAjax(this.record.recordFormData, recordData => {
            //跟进记录id赋值到售后工单上
            this.record.reviewFormData.followingUpNoteIdAfterSale = recordData._id;
            //通话记录id赋值到售后工单上
            this.record.reviewFormData.callIdAfterSale = this.objectData.callId;
            this.saveReview(this.record.reviewFormData, () => {
              this.hangUp(this.objectData, true); //挂断电话
              this.disableBtn = false; //恢复禁用的按钮
              this.record.recordFormData = { exts: {} };
              this.record.openRecord = false;
              this.viewReload();
            });
          });
        }
      }
    },
    //保存跟进记录ajax
    saveRecordAjax(data, callback) {
      //跟进记录需要前端生成_id
      data._id = data._id ? data._id : this.randomUUid();
      let params = {
        bizType: this.objectData.bizType,
        bizId: this.objectData.bizId,
        callId: this.objectData.callId,
        callPhone: this.objectData.caller //被叫
      };
      params = Object.assign(params, data);
      this.osg.ajax(
        'followingUpNote/upsert.do',
        params,
        () => {
          // this.getRecord();
          // this.record.openRecord = false;
          // this.callId = '';
          if (callback) callback(params);
        },
        { noload: true }
      );
    },
    //保存NPS对象
    saveNPS(params, callback) {
      params.bizId = this.objectData.bizId;
      params.bizType = this.objectData.bizType;
      params.bizCode = this.objectData.formData.contractdocNum;
      params.exts = params.exts || {};
      //NPS对象exts里冗余存储伙伴字段(id，省市区，服务商名称)
      if (this.objectData.formData.partner) {
        params.partnerId = this.objectData.formData.partner._id;
        params.partnerName = this.objectData.formData.partner.name;
        params.partnerProvince = this.objectData.formData.exts.province;

        params.exts.partnerProvince = this.objectData.formData.exts.province;
        params.exts.partnerCity = this.objectData.formData.exts.city;
        params.exts.partnerDistrict = this.objectData.formData.exts.district;
      }
      //对NPS问题进行处理，将选择扣款的问题扣款
      // params.questionAndReply = params.questionAndReply.map(qItem => {
      //   if (qItem.whether > 0) {
      //     qItem.reply = String(qItem.question).slice(String(qItem.question).indexOf(',') + 1);
      //   } else {
      //     qItem.reply = '0';
      //   }
      //   return qItem;
      // });
      params.questionAndReply = params.questionAndReply.map(qItem => {
        if (!(qItem.whether > 0)) {
          qItem.reply = '0';
        }
        return qItem;
      });
      this.osg.ajax(
        'basic/nps/upsert.do',
        params,
        () => {
          if (callback) callback();
        },
        { noload: true }
      );
    },
    //选择罚款问题change事件
    selectionQuestion(opValue, row) {
      for (let item of this.options['questionBank']) {
        if (item._id == opValue) {
          row.reply = item.price || 0;
        }
      }
    },
    //查找参数表里的key
    findParameterKey(row, key) {
      let replyData = row.parameterList.find(paramItem => paramItem.key == key);
      return replyData && replyData.value;
    },
    //给字典表扩展属性
    getParameterData(sourceTypeType, callBack) {
      if (!sourceTypeType) return;
      this.osg.ajax(
        'code/query.do',
        {
          type: sourceTypeType,
          'nin:state|integer#and': [-1],
          _all: '1'
        },
        codeRes => {
          let params = {
            _all: '1',
            'in:state|array-integer#and': '0,1',
            'in:sourceType|integer#and': 2, //参数来源
            'is:sourceTypeType|string#and': sourceTypeType,
            sortField: 'key',
            sortOrder: 'desc'
          };
          this.osg.ajax(
            'parameter/query.do',
            params,
            res => {
              this.options[sourceTypeType] = codeRes.data.map(item => {
                item.parameterList = [];
                res.data.forEach(pItem => {
                  if (item._id == pItem.sourceTypeId) item.parameterList.push(pItem);
                });
                item.label = item.name;
                return item;
              });
              if (callBack) callBack();
            },
            { noload: true }
          );
        },
        { noload: true }
      );
    },
    //接受参数生成工单
    doSaveSA(params, callback) {
      debugger;
      if (!params) return;
      params.area = params.area || [];
      if (params.area.length > 0) {
        params.province = params.area[0] || '';
        if (params.area.length > 1) {
          params.city = params.area[1] || '';
          if (params.area.length > 2) {
            params.district = params.area[2] || '';
          }
        }
      }

      console.log(this.objectData.SAextFields);

      // 自定义字段转换值
      this.$util.saveFormatExtField(this.objectData.SAextFields, params);
      // 赋默工单标题
      params.title = params.name + '的工单' + this.$util.readableTime();
      console.log('要传递的参数', params);

      this.osg.ajax(
        'basic/serviceAppointment/upsert.do',
        { data: JSON.stringify(params) },
        res => {
          if (callback) callback(res.entity);
        },
        { noload: true }
      );
    },
    //生成的客户特殊接口，返回客户对象，并把客户的id和线索的id都互相存储
    upsertLead(params, callback) {
      let data = this.$util.deepCopy(params);
      data.area = data.area || [];
      if (data.area.length > 0) {
        data.province = data.area[0] || '';
        if (data.area.length > 1) {
          data.city = data.area[1] || '';
          if (data.area.length > 2) {
            data.district = data.area[2] || '';
          }
        }
      }
      this.saveExtField(this.objectData.extFields, data);
      if (data.gpsPoint) {
        data['gpsPoint.longitude'] = data.gpsPoint.longitude;
        data['gpsPoint.latitude'] = data.gpsPoint.latitude;
        delete data.gpsPoint;
      }
      delete data.exts.leakagesite_copy;
      delete data.exts.shbParams;
      this.osg.ajax(
        'basic/contacts/upsertLead.do',
        data,
        res => {
          if (callback) callback(res.entity);
        },
        {
          noload: true
        }
      );
    },
    //生成uuid（18位），随机数（5位）+时间戳（13位）
    randomUUid() {
      let num = '';
      for (var i = 0; i < 5; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return num + new Date().valueOf();
    },
    //转工单数据模板
    converTemp(row, assignData) {
      let obj = {
        // contactIds: [row._id],
        name: row.name,
        address: row.address,
        area: row.area,
        // belongTo: row.belongTo,
        province: row.province,
        city: row.city,
        district: row.district,
        subdistrict: row.subdistrict,
        serviceType: row.serviceType,
        phone: row.phone,
        channel: row.channel,
        exts: row.exts || {}
        // leadIds: [row._id]
      };
      //TODO:写死的，线索预设字段给工单扩展字段赋值
      obj.exts.retentionDate = this.objectData.formData.customTime || '';
      // 防止字段未{}，会返显为undefined
      if (obj.exts.retentionDate.constructor == Object) obj.exts.retentionDate = '';
      return Object.assign(obj, assignData ? assignData : {});
    },
    uploadSuccess(response, file, fileList, field, extFields) {
      //   if (!extFields) $this.formData[field] = fileList;
      console.log(fileList);
      return fileList;
    },
    //保存售后工单对象
    saveWorkflowAlert(exts, callback) {
      let extsData = this.$util.deepCopy(exts);
      //TODO:写死
      extsData.afterSaleType = JSON.stringify(extsData.afterSaleType);
      extsData.imagesAfterSale = JSON.stringify(extsData.imagesAfterSale);
      extsData.relatedPerson = Array.isArray(extsData.relatedPerson)
        ? extsData.relatedPerson.join(',')
        : '';
      //TODO:name和phone与工单的重了特殊处理
      extsData['nameAfterSaleSA'] = extsData.name;
      extsData['phoneAfterSaleSA'] = extsData.phone;
      delete extsData.name;
      delete extsData.phone;
      //将选择的关联人冗余存储中文
      let handleData = [];
      this.options['relatedPerson'].forEach(item => {
        if (this.record.SAafterSaleFormData.relatedPerson.indexOf(item._id) != -1) {
          handleData.push(item.name);
        }
      });
      if (handleData && handleData.length) extsData.handleUserNames = handleData.join('、');
      //拿到选中的工单对象
      let activeSA = this.options['sid'].filter(item => item._id == extsData.sid)[0];
      if (activeSA && activeSA.exts) {
        extsData.sTerritory = activeSA.exts.sTerritory; //工单片区
        extsData.orderNumSA = activeSA.orderNum; //工单编号
        extsData.leakagesite = JSON.stringify(activeSA.exts.leakagesite); //工单维修部位
        extsData.orgIdAfterSaleSA = activeSA.orgId; //工单服务商Id
        extsData.orgNameAfterSaleSA = activeSA.orgName; //工单服务商名称
        extsData.createTimeSA = activeSA.createTime; //工单创建时间
      }
      let params = {
        handlerIds: exts.relatedPerson,
        type: '1',
        type1Type: '1',
        memo: exts.describe,
        callId: [this.callId],
        exts: extsData
      };
      params.orgId = activeSA.orgId; //工单服务商Id
      this.osg.ajax(
        'biz/workflowAlert/addPostSalesService.do',
        params,
        () => {
          if (callback) callback();
        },
        { noload: true }
      );
    },
    //根据输入的手机号请求工单
    SAafterSalePhone() {
      if (this.record.SAafterSaleFormData.phone) {
        this.osg.ajax(
          'basic/serviceAppointment/query.do',
          {
            'regex:phone|string#and': this.record.SAafterSaleFormData.phone,
            rows: 100
          },
          res => {
            this.$set(this.options, 'sid', res.data);
          },
          {
            noload: true
          }
        );
      } else {
        this.$set(this.options, 'sid', []);
        this.record.SAafterSaleFormData.sid = '';
      }
    },
    // 保存回访表单
    saveReview(reviewFormData, callback) {
      this.osg.getExtByColName('review', extId => {
        reviewFormData.state = 1; // 默认状态1
        let url = 'biz/extForm/upsert/' + extId + '.do';
        this.osg.ajax(
          url,
          { dataStr: JSON.stringify(reviewFormData) },
          res => {
            if (callback) callback(res.entity);
          },
          { noload: true }
        );
      });
    },
    //切换工单,查询关联人
    sidChange() {
      if (
        this.record.SAafterSaleFormData.sid &&
        this.record.recordFormData.dedicateMode &&
        Array.isArray(this.record.recordFormData.dedicateMode)
      ) {
        this.osg.ajax(
          'biz/workflowAlert/queryAboutHandleUsers.do',
          {
            sid: this.record.SAafterSaleFormData.sid,
            code: this.record.recordFormData.dedicateMode[
              this.record.recordFormData.dedicateMode.length - 1
            ]
          },
          res => {
            this.$set(this.options, 'relatedPerson', res.data);
            this.record.SAafterSaleFormData.relatedPerson = '';
          },
          { noload: true }
        );
      } else {
        this.$set(this.options, 'relatedPerson', []);
        this.record.SAafterSaleFormData.relatedPerson = '';
      }
      this.$forceUpdate();
    },
    beforeUpload() {
      return this.osg.beforeUpload(...arguments, this);
    },
    beforeRemove() {
      return this.osg.beforeRemove(...arguments, () => {}, this);
    },
    //反显省市区
    formatProvince(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.county_list[cellValue];
    },
    // 解决自定义字段不能传数组
    saveExtField(extFields, row) {
      for (let field of extFields) {
        if (field.preset == '1') continue;
        if (field.type == 'checkbox' || field.type == 'cascade') {
          row.exts[field.name] = JSON.stringify(row.exts[field.name]);
        } else if (field.type == 'file') {
          if (Array.isArray(row.exts[field.name])) {
            row.exts[field.name] = row.exts[field.name].map(item => {
              return {
                url: this.osg.downloadUrl + item.response.key.replace(this.osg.downloadUrl, ''),
                name: item.response.key
              };
            });
          } else {
            row.exts[field.name] = [];
          }
        }
      }
      return row;
    },
    validate: function(formData, state) {
      formData = formData || 'formData';
      var pass = false;
      if (!this.$refs[formData]) return false;
      this.$refs[formData].$refs.formData.validate((valid, fileData) => {
        if (valid) pass = true;
        if (state == '0' || state == '2') {
          //创建线索，必填项忽略
          let ignoreObj = {
            area: true,
            phone: true,
            address: true,
            title: true,
            channel: true,
            'exts.sourceType': true,
            'exts.leakagesite': true
          };
          pass = true;
          for (let key in fileData) {
            //如果ignoreObj没有该字段则返回false
            if (!ignoreObj[key]) {
              pass = false;
            }
          }
        }
      });
      return pass;
    },
    validateCForm() {
      var pass = false;
      this.$refs['NPSform'].$refs['formData'].validate(valid => {
        if (valid) pass = true;
      });
      return pass;
    },
    // 删除空数组
    removeEmpty(arr, children) {
      let childrenName = children || 'children';
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item[childrenName] ? item[childrenName].length === 0 : false) {
            delete item[childrenName];
          } else {
            this.removeEmpty(item[childrenName]);
          }
        });
        return arr;
      }
    },
    // 获取历史服务工单
    getServiceAppointments() {
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          'is:phone|string#and': this.objectData.formData.phone,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.serviceAppointmentFpi = res;
        },
        { noload: true }
      );
    },
    //获取历史售后工单
    getWorkOrders() {
      var params = {
        _all: 1,
        'is:state|integer#and': 1,
        'is:phone|string#and': this.objectData.formData.phone,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/workOrder/query.do',
        params,
        res => {
          this.fpi = res;
        },
        { noload: true }
      );
    },
    getLeads() {
      this.osg.ajax(
        'basic/lead/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          'is:phone|string#and': this.objectData.formData.phone,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.leadFpi = res;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        },
        { noload: true }
      );
    },
    //获取跟进记录
    getRecord() {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:callPhone|string#or': this.objectData.formData.phone
      };
      this.osg.ajax(
        'followingUpNote/query.do',
        params,
        res => {
          if (res.data) {
            this.record.fpi = res;
            this.$nextTick(() => {
              this.$forceUpdate();
            });
          }
        },
        {
          noload: true
        }
      );
    },
    inputtipsSelect(item) {
      //赋值省市区编码、经纬度
      let areaData = {
        province: item.adcode.slice(0, 2) + '0000',
        city: item.adcode.slice(0, 4) + '00',
        district: item.adcode,
        area: [item.adcode.slice(0, 2) + '0000', item.adcode.slice(0, 4) + '00', item.adcode],
        gpsPoint: {
          longitude: item.location.split(',')[0],
          latitude: item.location.split(',')[1]
        }
      };
      if (
        areaData.province.startsWith('810') ||
        areaData.province.startsWith('820') ||
        areaData.province.startsWith('710')
      ) {
        this.osg.toast('港澳台请自行选择省市区', 'error');
        return;
      } else {
        //根据经纬度查询街道的编码
        this.osg.geocodeRegeo(item.location, addressComponent => {
          // 去掉后三位街道编码，和数据库街道编码格式保持一致
          areaData.subdistrict = addressComponent.towncode.slice(
            0,
            addressComponent.towncode.length - 3
          );

          //获取当前区下的所有街道供选择
          this.osg.getSubdistricts(areaData.area, result => {
            window.$this.options.subdistricts = result;
            if (!result.find(item => item.code == areaData.subdistrict)) {
              let obj = {
                label: addressComponent.township,
                value: addressComponent.township
              };
              window.$this.options.subdistricts.push(obj);
              areaData.subdistrict = addressComponent.township;
            }
            window.$this.$forceUpdate();
            this.changeForm(areaData);
          });
        });
      }
    },
    changeForm(data) {
      this.record.SArecordFormData = window.$this.$util.deepCopy(
        Object.assign(this.record.SArecordFormData, data)
      );
    },
    saveSupportHubItem() {
      let params = this.$util.deepCopy(this.SupportHubItemData);
      // 回访记录二级数组转字符串用于存储
      params.exts.followUp = JSON.stringify(params.exts.followUp);
      this.osg.ajax('basic/supportHub/upsertSupportHubItem.do', params, () => {
        this.osg.toast('保存成功！');
      });
    }
  },
  watch: {
    'record.SArecordFormData.area'() {
      if (this.$refs.areaSelectorRSA) {
        this.$refs.areaSelectorRSA.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'record.SArecordFormData'() {
      if (!this.record.SArecordFormData.gpsPoint) {
        this.record.SArecordFormData.gpsPoint = {};
      }
      if (!this.record.SArecordFormData.exts) {
        this.record.SArecordFormData.exts = {};
      }
    },
    //综合跟进表单，信息渠道
    'record.SArecordFormData.channel'() {
      if (this.$refs.cascaderRRchannel) {
        this.$refs.cascaderRRchannel.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //综合跟进表单，通话状态
    'record.recordFormData.dedicateMode'() {
      if (this.$refs.cascaderRRdedicateMode) {
        this.$refs.cascaderRRdedicateMode.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  },
  computed: {
    timingStr() {
      return `${this.timingHour}:${this.$util.fillZero(this.timingMinute)}:${this.$util.fillZero(
        this.timingSecond
      )}`;
    }
  }
};
</script>
<style lang="scss">
#phoneStrip-wrapper {
  width: 100%;
  height: 70px;
  position: sticky;
  z-index: 4000;
  top: 0px;
  right: 0;
  margin-bottom: 4px;
  border-radius: 0 0 5px 5px;
}
#phoneStrip-wrapper .el-menu-item {
  background-color: transparent !important;
}
#phoneStrip-wrapper ul li {
  height: 100%;
  line-height: 70px;
}
#phoneStrip-wrapper .is-active {
  background: #60626675 !important;
  border-bottom: 2px solid #60626675 !important;
  color: #fff;
}
#phoneStrip-wrapper .menu-wrapper {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: flex-end;
  flex: 1;
  border-bottom: none;
  border-radius: 4px;
}

#comprehensiveDialog .el-dialog {
  width: 70vw;
  min-width: 1000px;
  margin: 68px auto !important;
  border-radius: 0 0 5px 5px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 140px) !important;
}
#comprehensiveDialog .el-dialog__body {
  overflow-y: auto;
  flex: 1;
  padding: 20px 50px;
}
#comprehensiveDialog .el-dialog__footer {
  padding: 10px 15px;
  border-top: 1px solid #e8eaec;
  box-sizing: border-box;
}
#comprehensiveDialog .el-form-item__content > div {
  width: 100% !important;
}

#transferDialog .el-dialog {
  width: 1038px;
  min-width: 400px;
  max-width: 95%;
  max-height: 80vh;
  margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.el-message-box__wrapper {
  z-index: 9999 !important;
}

.el-form--inline {
  display: flex;
  flex-wrap: wrap;
}
.el-form--inline .el-input__inner {
  // width: 210px;
  width: 100%;
}
.el-form--inline .el-textarea__inner {
  // width: 210px;
  width: 100%;
}
.el-form--inline .el-form-item {
  width: 24%;
  margin-right: 1%;
  margin-bottom: 10px;
  .el-form-item__label {
    padding-bottom: 0 !important;
  }
  .el-input__suffix {
    right: 0;
  }
}

.el-form--inline .el-input__suffix {
  right: 40px;
}
#comprehensiveDialog .el-dialog__header {
  display: none;
}
</style>
